if (!customElements.get('page-toc')) {
  customElements.define(
    'page-toc',
    class PageToc extends HTMLElement {
      connectedCallback() {
        this.links = [...this.querySelectorAll('a[href^="#"]')];
        this.targets = this.links.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
        if (!this.targets.length) return;

        this.onScroll = this.update.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const offset = window.innerHeight * 0.3;
          let current = this.targets[0];
          for (const target of this.targets) {
            if (target.getBoundingClientRect().top - offset > 0) break;
            current = target;
          }
          this.links.forEach((link) => {
            if (link.hash === `#${current.id}`) {
              link.setAttribute('aria-current', 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        });
      }
    }
  );
}
